import { render, staticRenderFns } from "./EnviarDocumento.vue?vue&type=template&id=2b408b49"
import script from "./EnviarDocumento.vue?vue&type=script&lang=js"
export * from "./EnviarDocumento.vue?vue&type=script&lang=js"
import style0 from "./EnviarDocumento.vue?vue&type=style&index=0&id=2b408b49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports